import { i18n } from '@lingui/core'
import { SUPPORTED_LOCALES } from '../consts/supported-locales'

/** @type {string} */
export const CONFIG_LOCALE_CHANGED_EVENT = 'config-locale-changed'

/** @returns {string} */
export function getActiveConfigLocale() {
  const stored = localStorage.getItem('preferredLanguage')
  if (stored && SUPPORTED_LOCALES.includes(stored)) return stored
  return i18n.locale || 'en'
}

/**
 * @param {{ label?: string, labels?: Record<string, string>, displayLabel?: string } | null | undefined} item
 * @param {string} [locale]
 */
export function resolveConfigDisplayLabel(item, locale = getActiveConfigLocale()) {
  if (!item) return ''
  if (item.displayLabel) return item.displayLabel
  const fromDict = item.labels?.[locale] ?? item.labels?.en
  return fromDict ?? item.label ?? ''
}

/**
 * @param {{ label?: string, labels?: Record<string, string>, displayLabel?: string } | null | undefined} option
 * @param {string} [locale]
 */
export function resolveOptionDisplayLabel(option, locale = getActiveConfigLocale()) {
  return resolveConfigDisplayLabel(option, locale)
}

/**
 * Canonical option label for GeoJSON region matching (not localized).
 * @param {{ label?: string, Label?: string } | null | undefined} option
 */
export function resolveOptionMapGeoName(option) {
  if (!option) return ''
  const canonical = option.label ?? option.Label ?? ''
  return String(canonical).trim()
}

/**
 * @param {object} section
 * @param {string} [locale]
 */
export function resolveSectionDisplayLabel(section, locale = getActiveConfigLocale()) {
  return resolveConfigDisplayLabel(
    {
      label: section?.displayName,
      labels: section?.labels,
      displayLabel: section?.displayLabel,
    },
    locale,
  )
}

/**
 * @param {string | URL} baseUrl
 * @param {Record<string, string | number | null | undefined>} [extraParams]
 */
export function buildConfigLocalizedUrl(baseUrl, extraParams = {}) {
  const url = new URL(baseUrl, typeof window !== 'undefined' ? window.location.origin : undefined)
  url.searchParams.set('locale', getActiveConfigLocale())
  Object.entries(extraParams).forEach(([key, value]) => {
    if (value != null && value !== '') {
      url.searchParams.set(key, String(value))
    }
  })
  return url
}

/**
 * @param {Record<string, string>} [extra]
 */
export function getConfigLocaleHeaders(extra = {}) {
  const locale = getActiveConfigLocale()
  return {
    'Accept-Language': locale,
    ...extra,
  }
}

/**
 * @param {string} locale
 */
export function dispatchConfigLocaleChanged(locale) {
  if (typeof window === 'undefined') return
  window.dispatchEvent(
    new CustomEvent(CONFIG_LOCALE_CHANGED_EVENT, { detail: { locale } }),
  )
}
